<!-- search box -->
<div class="search-box" #searchBox>
  <div class="search-form flex items-center justify-center relative px-1 lg:px-2 lg:pr-3">
    <div class="search-form-container flex-1 flex justify-center items-center">
      <div class="search-form-content hidden md:grid md:grid-cols-5 ">
        <div class="input-colum mr-3" style="border-right: 1px solid var(--gainsboro-color)">
          <div class="label">{{'Where' | translate}}</div>
          <div class="flex justify-between">
            <div class="flex-1">
              <p-select #propertyComp 
                class="w-full" 
                [options]="searchOption.propertyCode"
                [(ngModel)]="searchFilter.propertyCode" 
                optionLabel="name" 
                id="location" 
                name="location"
                styleClass="w-full" 
                panelStyleClass="location-dropdown-panel"
                [filterPlaceholder]="'booking.please-select' | translate"
                [placeholder]="'Where' | translate" (onChange)="changePropertyCode($event)"
                [appendTo]="searchBox"
              />
            </div>
          <div class="dropdown-icon" (click)="openDialogOption('property')"></div>
          </div>
        </div>

        <div class="input-colum mr-3" style="border-right: 1px solid var(--gainsboro-color)">
          <div class="label">{{'Bedrooms' | translate}}</div>
          <div class="flex justify-between">
            <div class="flex-1 w-full">
              <p-multiSelect #bedRoomsComp 
                class="w-full" 
                [showHeader]="true"
                [filter]="false"
                [options]="searchOption.numberOfBedrooms" 
                [(ngModel)]="searchFilter.numberOfBedrooms" optionLabel="name"
                placeholder="{{'search-bar.bedrooms' | translate}}" 
                id="drop-down" 
                [showClear]="false" 
                required=true
                [appendTo]="searchBox"
                [showToggleAll]="true"
              >
                <ng-template #header>
                  <span class="z-10 material-symbols-outlined text-[20px] mr-2 cursor-pointer absolute top-[8px] right-0" (click)="hideDialogOption('numOfBed')">
                    close
                  </span>
                </ng-template>
                <ng-template let-value pTemplate="selectedItems">
                  <div class="inline-flex align-items-center" *ngFor="let option of getValue(value);index as i">
                    <div><span *ngIf="i !== 0">, </span>{{option.name}}</div>
                  </div>
                  <div *ngIf="value && value.length && searchOption && value.length === searchOption.numberOfBedrooms.length">
                    All</div>
                  <!-- <div *ngIf="!value || value.length === 0">{{'search-bar.bedrooms' | translate}}</div> -->
                </ng-template>
              </p-multiSelect>
            </div>
            <div class="dropdown-icon" (click)="openDialogOption('numOfBed')"></div>
          </div>
        </div>

        <div class="input-colum mr-3" style="border-right: 1px solid var(--gainsboro-color)">
          <div class="label">{{'Lease' | translate}}</div>
          <div class="flex justify-between">
            <div class="flex-1">
              <p-select 
                #leaseComp class="w-full" 
                [options]="searchOption.lease" 
                [(ngModel)]="searchFilter.lease"
                optionLabel="name" id="location" name="lease" styleClass="w-full"
                panelStyleClass="location-dropdown-panel" 
                [filterPlaceholder]="'booking.please-select' | translate"
                [placeholder]="'Lease' | translate"
                [appendTo]="searchBox"
              />
            </div>
            <div class="dropdown-icon" (click)="openDialogOption('lease')"></div>
          </div>
        </div>

        <!-- start date & end date -->
        <div class="input-colum mr-3" style="border-right: 1px solid var(--gainsboro-color)">
          <div class="label">{{'Start Date' | translate}}</div>
          <div class="flex justify-between">
            <div class="w-full pr-[8px] text-ellipsis">
              <p-datepicker 
                styleClass="w-full" 
                #arrivalDateComp 
                placeholder="{{'search-bar.move-in-date' | translate}}"
                [showIcon]="false" 
                [(ngModel)]="searchFilter.arrivalDate" 
                dateFormat="dd MM yy" [minDate]="currentDate"
                (ngModelChange)="onStartDateChange()" 
                (onMonthChange)="onStartDateMonthChange($event)"
                [disabledDates]="disabledStartDates"
                [appendTo]="searchBox"
              />
            </div>
            <div class="dropdown-icon ml-[-78px]" (click)="openDialogOption('arrivalDate')"></div>
          </div>
        </div>
        <!-- END start date & end date -->

        <div class="input-colum flex lg:block">
          <div>
            <div class="label">{{'Promotion' | translate}}</div>
            <div class="flex items-center">
              <!-- <input pInputText type="text" id="promoCode" name="promoCode" pInputText class="w-full sm:mr-2"
                            autocomplete="off" placeholder="{{'Promotion' | translate}}"> -->
              <input class="w-full sm:mr-2" pInputText type="text" id="promoCode" name="promoCode"
                [(ngModel)]="searchFilter.promotionCode" optionLabel="name"
                placeholder="{{'search-bar.promotion-code' | translate}}" />
            </div>
          </div>

        </div>

      </div>

      <div class="search-form-content md:hidden grid grid-cols-4 text-[12px]">
        <div class="text-left pr-2 pl-2 overflow-hidden text-ellipsis whitespace-nowrap "
          style="border-right: 1px solid var(--gainsboro-color)">{{getOptionFilterTitle('property')}}</div>
        <div class="text-left pr-2 pl-2 overflow-hidden text-ellipsis whitespace-nowrap "
          style="border-right: 1px solid var(--gainsboro-color)">{{getOptionFilterTitle('bedroom')}}</div>
        <div class="text-left pr-2 pl-2 overflow-hidden text-ellipsis whitespace-nowrap "
          style="border-right: 1px solid var(--gainsboro-color)">{{getOptionFilterTitle('lease')}}</div>
        <div class="text-left pr-2 pl-2 overflow-hidden text-ellipsis whitespace-nowrap">{{getOptionFilterTitle('startDate')}}</div>
        <!-- <div class="text-left pr-2 pl-2 overflow-hidden text-ellipsis whitespace-nowrap ">{{getOptionFilterTitle('promotion')}}</div> -->
      </div>
    </div>

    <div class="btn-search hidden md:flex" (click)="setParamQuery()">
      <span class="hidden md:block material-symbols-outlined text-[16px] lg:text-[24px] text-white">
        search
      </span>

    </div>
    <div class="btn-search flex md:hidden" (click)="openSetOptionFilter()">
      <span class=" material-symbols-outlined text-[16px] text-white">
        search
      </span>
    </div>
  </div>
</div>

<p-dialog appendTo="body" header="" [(visible)]="setOptionFilter.visible" styleClass="w-[90vw] lg:w-[60vw]" [draggable]="false"
  [modal]="true" class="login-modal">
  <ng-template pTemplate>
    <div class="search-dialog">
      <div class="max-w-[960px] mx-auto rounded-md lg:flex lg:justify-center lg:items-center">
        <div class="flex flex-col lg:grid grid-cols-7 gap-4 ">
          <div>
            <div class="text-left search-label">{{'search-bar.location' | translate}}*</div>
            <div class="lg:flex lg:justify-content-center ">
              <xn-dropdown #propertyCompDialog class="w-full" [options]="searchOption.propertyCode"
                [(ngModel)]="searchFilter.propertyCode" optionLabel="name" (onChange)="changePropertyCode($event)"
                placeholder="{{'search-bar.location' | translate}}"></xn-dropdown>
            </div>
          </div>
          <div>
            <div class="text-left search-label">{{'search-bar.bedrooms' | translate}}*</div>
            <div class="lg:flex lg:justify-content-center ">
              <p-multiSelect #bedRoomsCompDialog 
                class="w-full" 
                [showHeader]="true"
                [options]="searchOption.numberOfBedrooms" 
                [(ngModel)]="searchFilter.numberOfBedrooms" 
                optionLabel="name"
                placeholder="{{'search-bar.bedrooms' | translate}}" 
                id="drop-down" [showClear]="true" 
                [filter]="false"
                required=true>
                  <ng-template #header>
                    <span class="z-10 material-symbols-outlined text-[20px] mr-2 cursor-pointer absolute top-[8px] right-0" (click)="hideDialogOption('numOfBed')">
                      close
                    </span>
                  </ng-template>
                <!-- <ng-template let-value pTemplate="selectedItems">
                  <div class="inline-flex align-items-center" *ngFor="let option of getValue(value);index as i">
                    <div><span *ngIf="i !== 0">, </span>{{option.name}}</div>
                  </div>
                  <div
                    *ngIf="value && value.length && searchOption && value.length === searchOption.numberOfBedrooms.length">
                    All</div>
                  <div *ngIf="!value || value.length === 0">{{'search-bar.bedrooms' | translate}}</div>
                </ng-template> -->
              </p-multiSelect>
            </div>
          </div>
          <div>
            <div class="text-left search-label">{{'Lease' | translate}}</div>
            <div class="lg:flex lg:justify-content-center ">
              <xn-dropdown #leaseCompDialog class="w-full" [options]="searchOption.lease" [(ngModel)]="searchFilter.lease"
              optionLabel="name" id="location" name="lease" styleClass="w-full"
              panelStyleClass="location-dropdown-panel" [filterPlaceholder]="'booking.please-select' | translate"
              [autoDisplayFirst]="false" [placeholder]="'Lease' | translate">
            </xn-dropdown>
            </div>
          </div>
          <div>
            <div class="flex items-center search-label">{{'search-bar.start-date' | translate}}*
              <span [pTooltip]="tooltipContent" tooltipPosition="right"
                class="material-symbols-outlined text-[16px] ml-1 cursor-pointer text-accent">
                help
              </span>
              <ng-template #tooltipContent>
                <div>
                  {{"search-bar.lease-start-date" | translate}}
                </div>
              </ng-template>
            </div>
            <div class="lg:flex lg:justify-content-center ">
              <p-calendar appendTo="body" styleClass="w-full" #arrivalDateComp placeholder="{{'search-bar.move-in-date' | translate}}"
                [showIcon]="true" [(ngModel)]="searchFilter.arrivalDate" dateFormat="dd/mm/yy" [minDate]="currentDate"
                (ngModelChange)="onStartDateChange()" (onMonthChange)="onStartDateMonthChange($event)"
                [disabledDates]="disabledStartDates"></p-calendar>
            </div>
          </div>
          <div>
            <div class="text-left search-label">{{'search-bar.promotion-code' | translate}}</div>
            <div class="lg:flex lg:justify-content-center ">
              <input class="w-full" pInputText [(ngModel)]="searchFilter.promotionCode" optionLabel="name"
                placeholder="{{'search-bar.promotion-code' | translate}}" />
            </div>
          </div>
        </div>

        <div class="hidden btn-search lg:flex ml-4 mt-5" (click)="setParamQuery()">
          <img src="assets/images/search.svg">
        </div>

        <button class="btn btn-primary w-full mt-8" (click)="setParamQuery()">Search</button>
      </div>
    </div>
  </ng-template>
</p-dialog>